<template>
<BootstrapDialog title="学习资料" ref="dialog" size="lg" @afterOpen="afterOpen()" @afterClose="afterClose()" :modal-style="{'width':1200+'px'}">
	<template v-slot:body>
		<div class="modal-body wrapper-lg" style="width:100%">
		    <div class="row">
		        <div class="col-sm-4">
		            <div class="panel panel-default">
		                <div class="panel-body">
		                    <div class="row">
		                        <div class="col-sm-12 text-center">
		                            <div>
		                                <h3 style="margin-top: 2px;">{{kcdm}}-{{kcmc}}</h3>
		                            </div>
		                            <div class="text-primary">
		                                <h4>讲师：{{jsxm}}</h4>
		                            </div>
		                        </div>
		                    </div>
		                    <div class="row">
		                        <div class="col-sm-12">
		                            <ul class="nav nav-tabs" role="tablist">
		                                <li role="presentation" class="col-sm-6 active" style="padding: 0;"><a href="#menu1" aria-controls="menu1" role="tab" data-toggle="tab">课程目录</a></li>
		                                <li role="presentation" class="col-sm-6" style="padding: 0"><a href="#menu2" aria-controls="menu2" role="tab" data-toggle="tab">课程信息</a></li>
		                            </ul>
		                            <div class="tab-content">
		                                <div role="tabpanel active" class="tab-pane active" id="menu1">
		                                    <div v-if="chapterList && chapterList.length>0" class="list-group" style="margin-top: 5px;height: calc(100% - 180px);overflow-x: hidden;overflow-y: auto;">
		                                        <template v-for="(chapter, indexa) in chapterList">
		                                            <a href="javascript:void(0)" class="list-group-item" style="padding: 5px 15px;" :key="'chapter_id_' + chapter.id" :chapterid="chapter.id">
		                                                <span style="font-size: 16px;font-weight: 600;" class="text-success"><i class="fa fa-bookmark" aria-hidden="true"></i>&nbsp;第{{indexa+1}}章、{{chapter.name}}</span>
		                                            </a>
		                                            <a href="javascript:void(0)" class="list-group-item" style="padding: 5px 30px;" v-for="(lessson,indexb) in chapter.lessons"
		                                               :key="'lesson_id_'+lessson.id" :lessonid="lessson.id"
		                                               :class="{'active':activeLessonId == lessson.id}"
		                                               @click="toggle(chapter,lessson)">
		                                                <h5 class="list-group-item-heading">第{{indexb+1}}课时、{{lessson.lesson_name}}</h5>
		                                                <p class="list-group-item-text">
		                                                    课时简介：{{lessson.lesson_remark}}
		                                                </p>
		                                                <p class="list-group-item-text">
		                                                    时长： <span class="badge">{{lessson.lesson_minutes}}</span>分钟
		                                                </p>
		                                            </a>
		                                        </template>
		
		                                    </div>
		                                </div>
		                                <div role="tabpanel" class="tab-pane" id="menu2">
		                                    <div class="list-group" style="margin-top: 5px;height: calc(100% - 180px);overflow-x: hidden;overflow-y: auto;">
		                                        <a href="javascript:void(0)" class="list-group-item">
		                                            <h4 class="list-group-item-heading" style="font-weight: 600;">{{kcdm}}-{{kcmc}}</h4>
		                                            <p>课件简介：<br>{{kjjs}}</p>
		                                            <p>课件单位：<br>{{jgdm}}-{{jgmc}}</p>
		                                            <p>创建时间：<br>{{cjsj}}</p>
		                                            <p>状态：
		                                                <span class="text-success" v-if="zt=='OK'">开启</span>
		                                                <span class="text-danger" v-if="zt!='OK'">关闭</span>
		                                            </p>
		                                        </a>
		                                    </div>
		                                </div>
		                            </div>
		                        </div>
		                    </div>
		                </div>
		            </div>
		        </div>
		        <div class="col-sm-8" style="padding-left: 2px;">
		            <h3 class="m-t-none m-b font-thin"><i class="fa fa-plus" aria-hidden="true"></i>添加学习资料</h3>
		            <form role="form" class="form-horizontal" style="margin-top: 20px" id="pldr_form">
		                <div class="form-group">
		                    <label class="col-sm-2 control-label">请选择文件</label>
		                    <div class="col-sm-8">
		                        <file-upload id="zypx_kjgl_bt_imp_fp" ref="uploadBtn" @fileselected="fileselected"></file-upload>
		                    </div>
		                    <div class="col-sm-1" style="padding-left: 0px;">
		                        <button class="btn btn-primary btn-sm" type="button" @click="save()"><i class="fa fa-check"></i>保存</button>
		                    </div>
		                </div>
		            </form>
		            <BootstrapTable style="font-size: 14px;"
		                            ref="table"
		                            v-once
		                            :columns="columns"
		                            :options="{
											classes:'table table-hover',
											undefinedText:'',
											showColumns: false,
											sidePagination:'server',
											pagination:true,
											pageNumber:1,
											pageSize:10,
											pageList:[10,50,100,500],
											paginationPreText:'上一页',
											paginationNextText:'下一页',
											showExtendedPagination:false,
											paginationLoop:false
										}"
		                            @onPostBody="vueFormatterPostBody"
		                            @onPageChange="pageChange"
		            />
		        </div>
		    </div>
		</div>
	</template>
	<template v-slot:footer>
		<button style="margin-left:10px" class="btn btn-default" type="button" @click="close()">关闭</button>
	</template>
</BootstrapDialog>
</template>
<script>

    /**
     *职业鉴定-课件学习资料
     */
    import tableMixin from '@/mixins/table.js';
    export default {
        mixins: [tableMixin],
        name: "ZypxCourseLearnXxzl",
        components: {
        },
        data: function () {
            return {
                id:'',
                jsxm:'',
                kjdw:'',
                zt:'',
                kjjs:'',
                cjsj:'',
                kcdm:'',
                kcmc:'',
                jgdm:'',
                jgmc:'',
                chapterList:[],
                activeLessonId:'',
                query:{
                    kjId:'',
                    zjId:'',
                    keshiId:''
                },
                columns: [
                    {
                        title: '序号',
                        field: 'id',
                        align: 'center',
                        formatter: (value, row, index) => {
                            var options = this.$refs.table.getOptions();
                            return options.pageSize * (options.pageNumber - 1) + index + 1;
                        }
                    },
                    {
                        align: 'center',
                        field: 'zlmc',
                        title: '学习资料'
                    },
                    {
                        field: 'actions',
                        title: '操作',
                        align: 'center',
                        formatter: (value, row) => {
                            let html = "";
                            html += '<a target="_blank" href="' + row.xxdz + '">下载</a> | ';
                            html += '<a @click="del(row)">删除</a>';
                            return this.vueFormatter({
                                template: '<div class="operation_column">'
                                    + html
                                    + '</div>',
                                data: {row},
                                methods: {
                                    del: this.del,
                                }
                            })
                        }
                    }
                ]
            }
        },
        methods: {
			reset:function(){
				this.id = '';
				this.jsxm = '';
				this.kjdw = '';
				this.zt = '';
				this.kjjs = '';
				this.cjsj = '';
				this.kcdm = '';
				this.kcmc = '';
				this.jgdm = '';
				this.jgmc = '';
				this.chapterList = [];
				this.activeLessonId = '';
				this.query = {
				    kjId:'',
				    zjId:'',
				    keshiId:''
				};
				let result= {
				    total: 0,
				    rows: []
				};
				//table加载返回的数据
				this.$refs.table.load(result);
			},
			async open(params){
				this.id = params.id;
				this.query.kjId = params.id;
				let res = await this.$http.post('/htgl/inf/zypx/kj/hq',{id:this.id});
				if(res.data){
					this.jsxm = res.data.jsxm;
					this.kjdw = res.data.kjdw;
					this.zt = res.data.zt;
					this.kjjs = res.data.kjjs;
					this.kcdm = res.data.kcdm;
					this.kcmc = res.data.kcmc;
					this.jgdm = res.data.jgdm;
					this.jgmc = res.data.jgmc;
					this.cjsj = res.data.cjsj;
					this.chapterList = res.data.chapters;
					//学习资料   默认加载第一个课时的资料数据
					if(this.chapterList && this.chapterList.length > 0){
						let chapter = this.chapterList[0];
						if(chapter && chapter.lessons && chapter.lessons.length > 0){
							let lesson = chapter.lessons[0];
							this.activeLessonId = lesson.id;
							this.query.zjId = chapter.id;
							this.query.keshiId = lesson.id;
						}
					}
				}
				this.$nextTick(()=>{
					this.$refs.dialog.open();
				});
			},
			afterOpen:function(){
				this.search();
			},
			close:function(){
				this.$refs.dialog.close();
			},	
			afterClose:function(){
				this.$validator.reset();
				this.reset();
			},
            save:function(){
                if(this.file){
                    if(!this.query.kjId){
                        this.$error('未指定课件');
                        return;
                    }
                    if(!this.query.zjId){
                        this.$error('未指定章节');
                        return;
                    }
                    if(!this.query.keshiId){
                        this.$error('未指定课时');
                        return;
                    }
                    let formdata = new FormData();
                    formdata.append("kjId", this.query.kjId);
                    formdata.append("zjId", this.query.zjId);
                    formdata.append("keshiId", this.query.keshiId);
                    formdata.append("file", this.file);
                    this.$http.post('/htgl/inf/zypx/kjxxzl/xz', formdata, {'Content-Type': 'multipart/form-data'}).then(res => {
                        if (res.data) {
                            this.$success('操作成功',()=>{
                                this.$refs.uploadBtn.clear();
                                this.search();
                            });
                        }
                    });
                }
                else{
                    this.$error('请选择需要上传的资料');
                }
            },
            toggle:function(chapter, lesson){
                this.activeLessonId = lesson.id;
                //刷新表格数据
                this.query.zjId =  chapter.id;
                this.query.keshiId =  lesson.id;
                this.$refs.uploadBtn.clear();
                this.search();
            },
            fileselected: function (file) {
                this.file = file;
            },
            search:function(){
                //将数据表格的页码以及每一页展示的数据重置为1，10
                this.$refs.table.refreshOptions({pageNumber:1, pageSize:10});
                this.load(1,10);
            },
            //删除
            del: function (row) {
                this.$confirm('确定执行此操作吗', () => {
                    this.$http.post("/htgl/inf/zypx/kjxxzl/sc", {id: row.id}).then((res) => {
                        if (res.data == true) {
                            this.$success('操作成功', () => {
                                this.load();//刷新列表
                            });
                        }
                    });
                });
            },
            load:function(pageNumber, pageSize){
                this.query.current = pageNumber || this.query.current;
                this.query.size = pageSize || this.query.size;
                this.$http.post('/htgl/inf/zypx/kjxxzl/cx',this.query).then(res=>{
                    let data = res.data;
                    //封装返回值
                    let result= {
                        total: data.total,
                        rows: data.records
                    };
                    //table加载返回的数据
                    this.$refs.table.load(result);
                });
            },
            pageChange:function(pageNumber, pageSize){
                this.load(pageNumber, pageSize);
            }
        }

    }
</script>
<style scoped>


</style>
